import { render } from "./InterventionRequest.vue?vue&type=template&id=1f89d6d8&scoped=true&ts=true"
import script from "./InterventionRequest.vue?vue&type=script&lang=ts"
export * from "./InterventionRequest.vue?vue&type=script&lang=ts"

import "./InterventionRequest.vue?vue&type=style&index=0&id=1f89d6d8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f89d6d8"]])

export default __exports__